/**
 * `sizes` for a block that spans the page width. The page reserves
 * `--padding-side: 16px` on each side, so the box is the viewport minus 32px
 * until the layout container caps it.
 */
export const BLOCK_SIZES_MOBILE = 'calc(100vw - 32px)';

/**
 * `sizes` for a full-width block on desktop. The cap is `--layout-max-width`,
 * which is 1400px on MCosmetic — the tenant these blocks are designed around,
 * as their hardcoded `aspect-1400/*` ratios show — and 1200px elsewhere. A
 * media query cannot read the variable, so the wider value is used for both:
 * overstating the box only ever picks a larger candidate, never a blurry one.
 */
export const BLOCK_SIZES_DESKTOP =
  '(min-width: 1432px) 1400px, calc(100vw - 32px)';

/**
 * Candidates for a full-bleed block on the mobile branch, which `useGlobal`
 * defines as everything up to a 1024px viewport — tablets included.
 *
 * 1280 covers a 3x phone (~1083px for a 361px box). 1920 exists for the tablet
 * end of that range: a 2x tablet at 1024px needs about 1984px, and without it
 * the widest candidate would be upscaled by half again.
 */
export const BLOCK_WIDTHS_MOBILE = [480, 800, 1280, 1920];

/**
 * Candidates for a full-width block on desktop, up to a 2x-ish density.
 *
 * 1440 is not a rounding of 1280: a browser picks the narrowest candidate that
 * still covers the box, so a 1400px-wide block at 1x would otherwise jump
 * straight to 1920 and download nearly twice the bytes for the same rendered
 * pixels. 1440 is what this block requested before it became responsive.
 */
export const BLOCK_WIDTHS_DESKTOP = [800, 1280, 1440, 1920];
